// FOUNDER-LOCKED COPY — do not edit, paraphrase, re-case, or add punctuation.
// Any future styling/content pass MUST preserve these strings exactly.
export const FOUNDER_QUOTE = "Once you eliminate fear, the only thing left is opportunity.";
// Split only for typographic emphasis of the final word; the sentence must stay intact.
export const FOUNDER_QUOTE_LEAD = "Once you eliminate fear, the only thing left is ";
export const FOUNDER_QUOTE_EMPH = "opportunity.";
